import React from 'react';
import MLargeViewMeetingStatusComponent from '../mentorSchedulingComponentsNew/mCalendarRightContainer/components/mCalendarRequestsItemComponent/components/mLargeViewMeetingComponents/mLargeViewMeetingStatusComponent/mLargeViewMeetingStatusComponent';
import MBookingOptionRow from '../mentorSchedulingComponentsNew/mCalendarRightContainer/components/mCalendarRequestsItemComponent/components/mBookingOptionRow/mBookingOptionRow';
import VIDABOO_CONSTANTS from '../../../config/consts';
import acceptIcon from '../../../assets/svg/tick.svg';
import copyIcon from '../../../assets/svg/copy-button.svg';
import declineIcon from '../../../assets/svg/cross.svg';
import greenVIcon from '../../../assets/svg/green-v.svg';
import questionMarkIcon from '../../../assets/svg/question-icon.svg';
import './meetingRecipientsComponent.css';
import Spinner from '../../common/genericComponents/spinner';

const MeetingRecipientsComponentRender = ({
  requester = {},
  currentUserId = '',
  recipients = [],
  proposals = [],
  sortedRecipients,
  isSeeGuestBtnClicked,
  recipientsWrapRef,
  handleCopyIcon,
  copiedEmailItemIdx,
  showFadeInBottomBg,
  selectedRowIndex,
  setIsSeeAllProposalsClicked,
  isSeeAllProposalsClicked,
  setShowFadeInBottomBg,
  setIsSeeGuestBtnClicked,
  setSelectedRowIndex,
  ...props
}) => {
  const PROPOSAL_WRAPPER_HEIGHT = 180; //Height of proposal container, used for displaying fading effect in bottom of container if proposal or recipients are more. This height is synced with class "et-n-mac-proposals-container" defined in meetingRecipientsComponent.css
  const renderUIWithoutProposals = () => {
    const requesterStatusIcon = requester.status
      ? requester.status ===
        VIDABOO_CONSTANTS.BOOKING_FLOW_USER_STATES.CONFIRMED
        ? acceptIcon
        : declineIcon
      : questionMarkIcon;
    return (
      <>
        <div className="et-n-mac-recipients-count-txt">
          {sortedRecipients.length > 1
            ? sortedRecipients.length + ' Guests'
            : 'Guest'}
        </div>
        <div
          id="et-mrc-top-id"
          className={`et-n-mac-container ${
            isSeeGuestBtnClicked ? 'et-n-mac-container-large' : ''
          }`}>
          <div
            ref={recipientsWrapRef}
            className={`et-n-mac-requester-recipients-wrap ${
              sortedRecipients.length > 3 && !isSeeGuestBtnClicked
                ? 'et-n-mac-requester-recipients-wrap-without-scroll'
                : ''
            }`}>
            {requester.email && (
              <div
                className="et-n-mac-icon-email-requester-txt-wrap et-n-mac-bottom-border"
                onDoubleClick={() => {
                  handleCopyIcon(requester.email, 0);
                }}>
                <div className="et-n-mac-icon-email-txt-wrap">
                  <div className="et-n-mac-icon-wrap">
                    <img src={requesterStatusIcon} alt={'iconImg'} />
                  </div>
                  <div
                    className={`et-n-mac-email-txt ${
                      currentUserId === requester.userId
                        ? 'et-n-mac-email-txt-bold'
                        : ''
                    }`}>
                    {requester.email}
                  </div>
                  <img
                    className="et-n-mac-copy-icon-img"
                    src={copiedEmailItemIdx === 0 ? greenVIcon : copyIcon}
                    alt={'copyImg'}
                    onClick={() => {
                      handleCopyIcon(requester.email, 0);
                    }}
                  />
                </div>
                <div className="et-n-mac-requester-txt">Requester</div>
              </div>
            )}
            {sortedRecipients.map((recipient, idx) => {
              const recipientStatusIcon =
                recipient.status ===
                VIDABOO_CONSTANTS.BOOKING_FLOW_USER_STATES.CONFIRMED
                  ? acceptIcon
                  : recipient.status ===
                      VIDABOO_CONSTANTS.BOOKING_FLOW_USER_STATES.CREATED
                    ? questionMarkIcon
                    : declineIcon;

              return (
                <div
                  key={idx}
                  className="et-n-mac-icon-email-requester-txt-wrap"
                  onDoubleClick={() => {
                    handleCopyIcon(recipient.email, idx + 1);
                  }}>
                  <div className="et-n-mac-icon-email-txt-wrap">
                    <div className="et-n-mac-icon-wrap">
                      {recipientStatusIcon && (
                        <img src={recipientStatusIcon} alt={'iconImg'} />
                      )}
                    </div>
                    <div
                      className={`et-n-mac-email-txt ${
                        currentUserId === recipient.userId
                          ? 'et-n-mac-email-txt-bold'
                          : ''
                      }`}>
                      {recipient.email}
                    </div>
                    <img
                      className="et-n-mac-copy-icon-img"
                      src={
                        copiedEmailItemIdx === idx + 1 ? greenVIcon : copyIcon
                      }
                      alt={'copyImg'}
                      onClick={() => {
                        handleCopyIcon(recipient.email, idx + 1);
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          {sortedRecipients.length > 3 && !isSeeGuestBtnClicked && (
            <div
              className="et-n-mac-view-more-guests"
              onClick={() => {
                setIsSeeGuestBtnClicked(true);
              }}>
              See {sortedRecipients.length} Guests
            </div>
          )}
        </div>
      </>
    );
  };

  const renderUIWithProposals = () => {
    const handleSeeAllAndLessClick = (isSeeAllProposalsClicked) => {
      setIsSeeAllProposalsClicked(isSeeAllProposalsClicked);
      if (isSeeAllProposalsClicked) {
        if (
          recipientsWrapRef.current?.offsetHeight >
          PROPOSAL_WRAPPER_HEIGHT - 10
        ) {
          setShowFadeInBottomBg(true);
        }
      }
      if (!isSeeAllProposalsClicked) {
        if (recipientsWrapRef.current) {
          recipientsWrapRef.current.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }
      }
    };

    const handleScroll = () => {
      if (
        recipientsWrapRef.current?.scrollTop -
          (recipientsWrapRef.current?.scrollHeight -
            recipientsWrapRef.current?.offsetHeight) >
        0
      ) {
        setShowFadeInBottomBg(false);
      } else {
        setShowFadeInBottomBg(true);
      }
    };

    return (
      <>
        {!props.isAnonymousPage && (
          <div className="et-n-mac-recipients-count-txt">
            {'You have new time proposals'}
          </div>
        )}
        <div
          ref={recipientsWrapRef}
          onScroll={handleScroll}
          className={`et-n-mac-proposals-container ${
            isSeeAllProposalsClicked
              ? showFadeInBottomBg
                ? 'et-n-mac-proposals-container-faded'
                : ''
              : 'et-n-mac-requester-recipients-wrap-without-scroll'
          }`}>
          <div className="et-n-mac-proposal-header">
            <MLargeViewMeetingStatusComponent
              meetingStatus={'PROPOSALS'}
              statusText={
                requester.userId === currentUserId
                  ? 'PENDING PROPOSAL'
                  : 'NEW PROPOSAL'
              }
              hideTooltip={true}
            />
            {requester.userId === currentUserId && (
              <div
                className="et-n-mac-dismiss-all-spinner-wrap"
                onClick={() => props.onDismissAll(props.exBfiDto)}>
                {props.showDismissAllSpinner ? (
                  <div className="et-n-events-calander-approve et-n-smallest-spinner">
                    <Spinner />
                  </div>
                ) : (
                  'Dismiss all'
                )}
              </div>
            )}
          </div>
          {sortedRecipients.map((recipient, idx) => {
            const recipientStatusIcon =
              recipient.status ===
              VIDABOO_CONSTANTS.BOOKING_FLOW_USER_STATES.CONFIRMED
                ? acceptIcon
                : recipient.status ===
                    VIDABOO_CONSTANTS.BOOKING_FLOW_USER_STATES.CREATED
                  ? questionMarkIcon
                  : declineIcon;
            return (
              <div className="et-n-mac-proposal-wrap" key={idx}>
                <div
                  className="et-n-mac-proposal-icon-email-wrap"
                  onDoubleClick={() => {
                    handleCopyIcon(recipient.email, idx);
                  }}>
                  <div className="et-n-mac-proposal-icon-wrap">
                    {recipientStatusIcon && (
                      <img src={recipientStatusIcon} alt={'iconImg'} />
                    )}
                  </div>
                  <div
                    className={`et-n-mac-proposal-email-txt ${
                      currentUserId === recipient.userId
                        ? 'et-n-mac-email-txt-bold'
                        : ''
                    }`}>
                    {requester.userId === currentUserId
                      ? recipient.email
                      : requester.email}
                  </div>
                  <img
                    className="et-n-mac-copy-icon-img"
                    src={copiedEmailItemIdx === idx ? greenVIcon : copyIcon}
                    alt={'copyImg'}
                    onClick={() => {
                      handleCopyIcon(recipient.email, idx);
                    }}
                  />
                </div>
                <div
                  className={`et-n-mac-proposal-option-wrap ${
                    requester.userId === currentUserId
                      ? ''
                      : 'et-n-mac-proposal-option-hide-approval'
                  }`}>
                  {proposals
                    .filter(
                      (proposal) =>
                        proposal.proposingUserId === recipient.userId,
                    )
                    .map((proposal, idx) => {
                      return (
                        <MBookingOptionRow
                          key={idx}
                          isAnonymousPage={props.isAnonymousPage}
                          showAcceptMeetingIcon
                          bookingOption={proposal}
                          primaryTimezone={
                            props.calendarContext.primaryTimezone
                          }
                          secondaryTimezone={props.secondaryTimezone}
                          currentUser={props.currentUser}
                          exBfiDto={props.exBfiDto}
                          index={idx}
                          approveBookingOptionMeeting={(
                            exBfiDto,
                            bookingOption,
                          ) => {
                            setSelectedRowIndex(idx);
                            props.approveBookingOptionMeeting(
                              exBfiDto,
                              bookingOption,
                            );
                          }}
                          calendarContext={props.calendarContext}
                          handleClick={props.handleClick}
                          isSelected={
                            (props.isAnonymousPage &&
                              idx === selectedRowIndex) ||
                            (proposal.rangeStartTimeSender ===
                              props.calendarContext.selectedBookingOption
                                ?.rangeStartTimeSender &&
                              props.exBfiDto.bookingFlowInstanceDto
                                ?.bookingFlowInstanceId ===
                                props.calendarContext.exBfiDto
                                  .bookingFlowInstanceDto
                                  ?.bookingFlowInstanceId)
                          }
                          showSpinner={props.showApproveMeetingSpinner}
                        />
                      );
                    })}
                </div>
              </div>
            );
          })}
          {/* Show "See all proposals" only if there are more than 3 rows in container*/}
          {proposals.length > 0 &&
            ((props.isAnonymousPage && recipients.length > 1) ||
              (!props.isAnonymousPage && recipients.length > 2)) &&
            !isSeeAllProposalsClicked && (
              <div
                className="et-n-mac-see-all-wrap"
                onClick={() => {
                  handleSeeAllAndLessClick(true);
                }}>
                <div className="et-n-mac-see-all-txt">See all proposals</div>
              </div>
            )}
          {isSeeAllProposalsClicked && (
            <div
              className="et-n-mac-see-less-wrap"
              onClick={() => {
                handleSeeAllAndLessClick(false);
              }}>
              <div className="et-n-mac-see-less-txt">See less</div>
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      {proposals.length > 0
        ? renderUIWithProposals()
        : renderUIWithoutProposals()}
    </>
  );
};

export default MeetingRecipientsComponentRender;
